import { Stack, Typography } from '@mui/material'
import { SubscriptionPeriod, SubscriptionPlanType } from 'models/user/userWorkspaceDTOs'

import { CORAL_600 } from 'constants/styling/theme'
import { ChoosePlan } from 'components/common/ChoosePlan'
import { FC } from 'react'
import { MUIButton } from 'components/common/MUIButton'
import { MUITooltip } from 'components/common/MUITooltip'
import Modal from 'components/common/Modals/Modal/Modal'
import { PlanCardVariant } from 'constants/subscription'
import { getCancelSubscriptionLink } from 'utils/localization/subscriptionGoogleForms'
import i18n from 'translations/i18n'
import moment from 'moment-timezone'
import { useTranslation } from 'react-i18next'

interface Props {
  /** Whether the modal is visible */
  isOpen: boolean
  /** Callback to close the modal */
  onClose: () => void
  /** The workspace's active subscription plan */
  currentPlan: SubscriptionPlanType
  /** Callback when a plan card is selected */
  onSelectPlan: (plan: SubscriptionPlanType, period: SubscriptionPeriod) => void
  /** Date when the workspace subscription will be terminated */
  terminatedAt?: string
}

export const ManageSubscriptionModal: FC<Props> = ({
  isOpen,
  onClose,
  currentPlan,
  onSelectPlan,
  terminatedAt,
}) => {
  const { t } = useTranslation(['workspace_settings', 'pricing_page', 'common'])

  const handleCancelSubscription = () => {
    window.open(getCancelSubscriptionLink(i18n.language), '_blank', 'noopener,noreferrer')
  }

  return (
    <Modal
      isOpen={isOpen}
      title={t('workspace_settings:plan.manage_subscription')}
      onClose={onClose}
      onClickOutside={onClose}
      contentStyle={{ width: '100rem' }}
      footerContent={
        <Stack direction="row" justifyContent="space-between" alignItems="center" width="100%">
          {!terminatedAt && (
            <MUITooltip
              content={t('workspace_settings:plan.cancel_subscription_tooltip')}
              placement="top"
              sx={{ width: '26rem' }}
            >
              <MUIButton
                type="orangeSecondaryBorder"
                onClick={handleCancelSubscription}
              >
                {t('workspace_settings:plan.cancel_subscription')}
              </MUIButton>
            </MUITooltip>
          )}

          {!!terminatedAt && (
            <Typography variant="text-md" fontWeight={400} color={CORAL_600}>
              {t('workspace_settings:workspace_active_until', { date: moment(terminatedAt).format('DD.MM.YYYY') })}
            </Typography>
          )}

          <Stack direction="row" gap="0.8rem">
            <MUIButton type="secondaryNoBorder" onClick={onClose}>
              {t('common:Cancel')}
            </MUIButton>
          </Stack>
        </Stack>
      }
    >
      <ChoosePlan
        currentPlan={currentPlan}
        onSelectPlan={onSelectPlan}
        variant={PlanCardVariant.MANAGE}
      />
    </Modal>
  )
}
